import GetImagePdf from '../getImagePdf'
import { EyeOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { IAssetFile } from 'interfaces'

interface IProps {
  ids?: Array<number>
  assets?: Array<IAssetFile>
  onClick?: () => void
}
const ImagePdfPreview = (props: IProps) => {
  const { ids, onClick, assets } = props
  return (
    <>
      <Row gutter={4}>
        {ids &&
          ids?.map((id, index) => (
            <Col key={index}>
              <GetImagePdf
                imageId={id}
                width={40}
                preview={{ mask: <EyeOutlined /> }}
                onClick={onClick}
              />
            </Col>
          ))}
        {assets &&
          assets?.map((img) => (
            <Col key={img?.asset_id}>
              <GetImagePdf
                width={40}
                url={img?.public_access_url}
                fileType={img?.mime_type}
                preview={{ mask: <EyeOutlined /> }}
                onClick={onClick}
              />
            </Col>
          ))}
      </Row>
    </>
  )
}

export default ImagePdfPreview
